import { render, staticRenderFns } from "./UpdateRoleDialog.vue?vue&type=template&id=6a972bd6"
import script from "./UpdateRoleDialog.vue?vue&type=script&lang=js"
export * from "./UpdateRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports